export default __webpack_public_path__ + "static/media/chip_1.f1fe084b.svg";